import { en } from "./en.strings.ts";
import { ru } from "./ru.strings.ts";

interface OnboardingStrings {
  start: string;
  satiety: string;
  clean: string;
  energy: string;
  mood: string;
  eggs: string;
}

export interface LanguageStrings {
  hello: string;
  loading: string;
  play: string;
  create: string;
  choosePetButton: string;
  lowSatietyNotification: string;
  lowCleanNotification: string;
  lowEnergyNotification: string;
  lowMoodNotification: string;
  lowHealthNotification: string;
  manyPoopNotification: string;
  petLeaveNotification: string;
  petNotYetCreatedNotification: string;
  startCommandNoPetText: string;
  startCommandHasPetText: string;
  startCommandPetLeaveText: string;
  secondDayNotification: string;
  petCreatedNotification: string;
  petRevivedNotification: string;
  referalUserCreatedNotification: string;
  dailyCommandSuccess: string;
  dailyCommandFail: string;
  dailyCommandFailNoAlivePet: string;
  dailyCommandFailNotDailyStartActivated: string;
  dailyCommandFailTodayAlreadyClaimed: string;
  onboarding: OnboardingStrings;
  share: string;
  shareMessage: string;
  shareMiniGameResultMessage: string;
  donate: string;
  donateSuccess: string;
  leaderboardTitle: string;
  leaderboardEntry: string;
  leaderboardYourPosition: string;
  leaderboardNoPet: string;
  gameLeaderboardTitle: string;
  gameLeaderboardEntry: string;
  gameLeaderboardYourPosition: string;
  gameLeaderboardNoPet: string;
  settings: string;
  statsTitle: string;
  statsInfo: string;
  statsNoPet: string;
  petNames: {
    cat: string;
    dog: string;
    capy: string;
    parrot: string;
    shark: string;
  };
  yourPetDead: string;
  savePet: string;
  saveProgress: string;
  or: string;
  loseProgress: string;
  resurrectButton: string;
  resurrectByAdButton: string;
  createNewButton: string;
  catchFoodScene: {
    score: string;
    miss: string;
    obstacleCatched: string;
    exit: string;
    share: string;
    leaderboard: string;
    again: string;
    newRecord: string;
    leaderboardError: string;
    continueTitle: string;
    continueButton: string;
    resultsButton: string;
    timer: string;
  };
  currencyShopScene: {
    getEggs: string;
    invite: string;
    motivationText: string;
    supportText: string;
    ourChannelText: string;
    exit: string;
    donateError: string;
  };
  statRestoreOverlay: {
    notEnoughCoins: string;
    energy: string;
    satiety: string;
    mood: string;
    clean: string;
    restoreWithAd: string;
    adWarningText: string;
  };
  settingsOverlay: {
    music: string;
    sound: string;
  };
  sceneTransitions: {
    backToPet: string;
    eggsPurchased: string;
    brakeEgg: string;
    choosePet: string;
    petIsBack: string;
    petIsDead: string;
    createPet: string;
    welcomeBack: string;
    goingBack: string;
    home: string;
    shop: string;
    startingGame: string;
    gamesList: string;
  };
  foodShopOverlay: {
    title: string;
    buyFood: string;
    currentFood: string;
    notEnoughCoins: string;
  };
}

export const strings: { en: LanguageStrings; ru: LanguageStrings } = {
  en,
  ru,
};
